module.exports = __webpack_public_path__ + "img/LogoFriaxBlanco.15997f30.svg";